import React from 'react';
export function NextMoveSection() {
  return <div className="bg-[#1874cd] p-8 rounded-xl shadow-sm text-center text-white" data-id="element-3015">
      <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-3016">The Next Move</h2>
      <p className="text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-3017">
        It has been said that doing something is better than doing nothing.
        Start conversing with your co-workers. Talk to other companies and find
        out what they are doing to improve quality, communication and
        productivity inside their WEDM facility. But hurry up and do it now -
        the clock is still ticking!
      </p>
    </div>;
}